<template>
  <transition name="slide-up-down">
    <div v-if="userResponsesError" class="friskkollen-error-footer pt-5 pb-2">
      <div class="d-flex align-items-center justify-content-center px-4 mb-4">
        <i class="bi bi-exclamation-triangle-fill fs-3 text-danger me-3"></i>
        <span class="fs-2">{{ userResponsesError }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UserResponseError',
  props: {
    userResponsesError: {
      type: String,
      default: ''
    }
  }
}
</script>
